import { IModalService } from "angular-ui-bootstrap";
import { IExtraOptionPrototype } from "infrastructure/interfaces/IExtraMenuOption";
import { CONTRACT_STATUSES } from "application/constants";
import { AnnulModal } from "application/osago/components/ugsk-osago-annul-modal/ugsk-osago-annul-modal";
import annulModalTemplate from "application/osago/components/ugsk-osago-annul-modal/ugsk-osago-annul-modal.html";

export default {
    disabled(context: any): boolean {
        const contract: any = context.Contract;
        const userHasPermission = context.originalEmployee.hasPermission("Annul", "Osago");
        const statusesWhiteList = [
            CONTRACT_STATUSES.DRAFT,
            CONTRACT_STATUSES.PREPARED_FOR_SIGNING,
            CONTRACT_STATUSES.SIGNED,
        ];
        if (context.viewType === "journal") {
            if (userHasPermission && statusesWhiteList.includes(contract.StatusId) && !contract.IsPaid) {
                return false;
            }
        } else {
            if (userHasPermission && statusesWhiteList.includes(contract.ContractStatusId) && !contract.IsPayed) {
                return false;
            }
        }
        return true;
    },
    action(context): void {
        const $uibModal = context.di<IModalService>("$uibModal");
        $uibModal
            .open({
                controller: AnnulModal,
                controllerAs: "vm",
                resolve: {
                    context,
                },
                size: "lg",
                template: annulModalTemplate,
            })
            .result.then(({ result }) => {
                (context as any).showCommonErrorsNotifications(result.response.MessageObject.CommonErrors || result.response.Errors.CommonErrors);
            })
            .catch(() => {});
    },
    icon: "fa-times",
    title: "Аннулировать договор",
    tooltip: "Доступно только для договоров в статусе &#34;Оформлен&#34;/&#34;Подготовлен к продаже&#34; и &#34;Не оплачен&#34;",
} as IExtraOptionPrototype;
